import Bolt from './icons/bolt';
import Time from './icons/time';
import Error from './icons/error';

const active = {
  statusButton: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#00ad09',
    height: '24px',
    borderRadius: '12px',
    padding: '0 8px 0 8px',
  },
  statusButtonText: {
    fontSize: '12px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.07px',
    textAlign: 'center',
    color: '#fafafa',
    paddingLeft: '5px',
  },
};
Object.freeze(active);

const inuse = {
  statusButton: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#207ed8',
    height: '24px',
    borderRadius: '12px',
    padding: '0 8px 0 8px',
  },
  statusButtonText: {
    fontSize: '12px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.07px',
    textAlign: 'center',
    color: '#fafafa',
    paddingLeft: '5px',
  },
};
Object.freeze(inuse);

const offline = {
  statusButton: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#8c8c8c',
    height: '24px',
    borderRadius: '12px',
    padding: '0 8px 0 8px',
  },
  statusButtonText: {
    fontSize: '12px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.07px',
    textAlign: 'center',
    color: '#fafafa',
    paddingLeft: '5px',
  },
};
Object.freeze(offline);

// Maps each evse status (see getEvseStatus) onto one of the
// three existing pill styles/icons.
const statusConfig = {
  available: { style: active, Icon: Bolt, labelKey: 'available' },
  occupied: { style: inuse, Icon: Time, labelKey: 'occupied' },
  connected: { style: inuse, Icon: Time, labelKey: 'connected' },
  charging: { style: inuse, Icon: Time, labelKey: 'charging' },
  reserved: { style: inuse, Icon: Time, labelKey: 'reserved' },
  unavailable: { style: offline, Icon: Error, labelKey: 'unavailable' },
};

function StatusButton(props) {
  const { status, statusText } = props;
  const { style, Icon, labelKey } = statusConfig[status] || statusConfig.unavailable;

  return (
    <div style={style.statusButton}>
      <span style={{ display: 'flex', alignItems: 'center' }}>
        <Icon />
      </span>
      <span style={style.statusButtonText}>{statusText[labelKey]}</span>
    </div>
  );
}

export default StatusButton;
